import { z } from 'zod';
import type { Ride } from '../domain/ride';
import { browserUuid } from '../domain/browser-crypto';
import { studioDraftSchema, type StudioDraft } from './studio-draft';
import { draftStorageKey } from './draft-storage';
import { emptyCinematicSequence } from '../../../renderer/src/cinematic-sequence';

const versionSchema = z.object({ id: z.string(), savedAt: z.string(), draft: studioDraftSchema });
export type EditVersion = z.infer<typeof versionSchema>;
const key = (ride: Ride) => `${draftStorageKey(ride)}:versions`;
export function loadEditVersions(ride: Ride): EditVersion[] {
  return z.array(versionSchema).parse(JSON.parse(localStorage.getItem(key(ride)) ?? '[]'));
}
/** Write the complete previous edit before changing the active composition. */
export function saveEditVersion(ride: Ride, draft: StudioDraft): EditVersion[] {
  const versions = loadEditVersions(ride);
  const next = [{ id: browserUuid(), savedAt: new Date().toISOString(), draft: studioDraftSchema.parse(draft) }, ...versions];
  localStorage.setItem(key(ride), JSON.stringify(next));
  return next;
}
export function freshStudioEdit(draft: StudioDraft): StudioDraft {
  return { ...draft, freshEdit: true, cinematicEnabled: false, cinematicSequence: emptyCinematicSequence(), progress: 0 };
}
